'use client'
import { memo } from 'react'
import styled from 'styled-components'
import { mq, vw } from '../styles'
import { Figure, Link } from '@/components'

interface ILogo {
  name: string
}

const LogoStyled = styled.div`
  figure {
    height: ${vw(28, 'mobile')};
    width: ${vw(207, 'mobile')};

    ${mq.greaterThan('nexus7')} {
      height: 40.7px;
      width: 301px;
    }

    ${mq.greaterThan('tablet')} {
      height: ${vw(28, 'desktop')};
      width: ${vw(207, 'desktop')};
    }

    ${mq.greaterThan('container')} {
      height: 22.72px;
      width: 168px;
    }
  }

  img {
    object-fit: contain;
  }
`
const mediaLogo = {
  type: 'svg' as const,
  alt: 'logo',
  size: { width: 207, height: 28 }
}

export const Logo = memo<ILogo>(({ name }) => {
  const mediaLogoWithSrc = {...mediaLogo, src: name === 'iluzione' ? '/images/svg/iluzione--logo.svg' : '/images/svg/corso--logo.svg' }
  return (
    <Link href='/' className='logo'>
      <LogoStyled>
        <Figure media={mediaLogoWithSrc}></Figure>
      </LogoStyled>
    </Link>
  )
})


